/**
 * Permissions Slice
 * Redux slice for permissions state management
 */

import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface PermissionsState {
  permissions: string[] // Plain JSON permissions array (not JWT)
  profileType?: string
  activeProfileId?: string
  userType?: string
  contextType?: string
  organizationSlug?: string
  branchSlug?: string
  /** True after workspace bootstrap (or refresh) has applied permission grants — sidebar/menu may render. */
  isRBACReady: boolean
  isLoading: boolean
  error: string | null
}

const initialState: PermissionsState = {
  permissions: [],
  isRBACReady: false,
  isLoading: false,
  error: null,
}

const permissionsSlice = createSlice({
  name: 'permissions',
  initialState,
  reducers: {
    setPermissions: (state, action: PayloadAction<{
      permissions: string[]
      profileType?: string
      activeProfileId?: string
      userType?: string
      contextType?: string
      organizationSlug?: string
      branchSlug?: string
    }>) => {
      state.permissions = action.payload.permissions
      state.profileType = action.payload.profileType
      state.activeProfileId = action.payload.activeProfileId
      state.userType = action.payload.userType
      state.contextType = action.payload.contextType
      state.organizationSlug = action.payload.organizationSlug
      state.branchSlug = action.payload.branchSlug
      state.isRBACReady = true
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload
    },
    resetPermissions: (state) => {
      state.permissions = []
      state.profileType = undefined
      state.activeProfileId = undefined
      state.userType = undefined
      state.contextType = undefined
      state.organizationSlug = undefined
      state.branchSlug = undefined
      state.isRBACReady = false
      state.error = null
    },
  },
})

export const {
  setPermissions,
  setLoading,
  setError,
  resetPermissions,
} = permissionsSlice.actions

export default permissionsSlice.reducer

